import { datadogRum } from '@datadog/browser-rum-slim';

import { mergeLDContextKeyAttributes } from './ldContextKeyAttributes';
import { nrSetCurrentRouteName, nrSetCustomAttribute } from './newRelicRum';

export function setRouteContext(pattern: string, owner?: string) {
  datadogRum.setGlobalContextProperty('pathTemplate', pattern);
  datadogRum.setGlobalContextProperty('owner', owner ?? 'unknown owner');
  nrSetCustomAttribute('pathTemplate', pattern);
  nrSetCustomAttribute('owner', owner ?? 'unknown owner');
  // Give New Relic BrowserInteraction/PageView events an accurate SPA route name.
  nrSetCurrentRouteName(pattern);
  mergeLDContextKeyAttributes({ pathTemplate: pattern, owner: owner ?? 'unknown owner' });
}
